import { useEffect, useMemo, useState } from 'react';

export const useDebounced = <T>(value: T, delay = 400): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const stableDelay = useMemo(() => delay, [delay]);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedValue(value), stableDelay);
    return () => clearTimeout(id);
  }, [value, stableDelay]);

  return debouncedValue;
};
